import ApiServiceBase from "@/services/api/apiServiceBase";

/**
 * Premium / Verotel subscription surface (legacy SubscriptionService name kept for UI).
 */
export class SubscriptionService extends ApiServiceBase {

    public async plans(): Promise<any> {
        return this.http?.get('/premium/plans');
    }

    public async lastPaymentStatus(): Promise<any> {
        return this.http?.get('/premium/last-payment-status');
    }

    public async createPayment(packageId: string | number): Promise<{paymentUrl: string}> {
        return this.http?.post('/verotel/create-payment', {packageId: String(packageId)});
    }

    public async cancel(): Promise<any> {
        return this.http?.post('/premium/cancel-subscription', {});
    }

    /**
     * Replaces RevenueCat sync — poll Verotel/payment status instead.
     */
    public async sync(): Promise<{subscribed: boolean; status?: any}> {
        const status = await this.lastPaymentStatus();
        const subscribed = Boolean(
            status
            && status.status
            && String(status.status).toUpperCase() !== 'NONE'
            && String(status.status).toUpperCase() !== 'FAILED'
            && String(status.status).toUpperCase() !== 'CANCELLED'
            && String(status.status).toUpperCase() !== 'CANCELED',
        );
        return {subscribed, status};
    }
}
